export default __webpack_public_path__ + "static/media/tv-on.0d208403.gif";